// utm

import url from 'root/common/util/url';

/**
 * 获取utm参数
 */
export const getUtmParams = (fromHash = false) => {
    const query = url.getQuery(undefined, {
        fromHash,
    });
    return {
        utmSource_var: query.utm_source || '',
        utmCampaign_var: query.utm_campaign || '',
        utmContent_var: query.utm_content || '',
        utmMedium_var: query.utm_medium || '',
        utmterm_var: query.utm_term || '',
    };
};
